import { blobticService } from '../../Commun/services/blobticService';

export interface MileageLog {
    id: number;
    uid?: string;
    vehicleId?: number;
    driverId?: number;
    startDate: Date;
    endDate: Date;
    startKm: number;
    endKm: number;
    distance: number;
    vehicleRegistration?: string;
    driverName?: string;
    lastUpdate?: Date;
    userId?: number;
}

interface MileageDto {
    KLM_IDF: number;
    KLM_UIDF: string;
    VEH_IDF?: number;
    DRV_IDF?: number;
    KLM_DATE_DEBUT?: string;
    KLM_DATE_FIN?: string;
    KLM_KM_DEBUT?: number;
    KLM_KM_FIN?: number;
    KLM_DISTANCE?: number;
    VEH_REGISTRATION?: string;
    DRV_NAME?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: MileageDto): MileageLog => ({
    id: dto.KLM_IDF,
    uid: dto.KLM_UIDF,
    vehicleId: dto.VEH_IDF,
    driverId: dto.DRV_IDF,
    startDate: dto.KLM_DATE_DEBUT ? new Date(dto.KLM_DATE_DEBUT) : new Date(),
    endDate: dto.KLM_DATE_FIN ? new Date(dto.KLM_DATE_FIN) : new Date(),
    startKm: dto.KLM_KM_DEBUT || 0,
    endKm: dto.KLM_KM_FIN || 0,
    distance: dto.KLM_DISTANCE || 0,
    vehicleRegistration: dto.VEH_REGISTRATION,
    driverName: dto.DRV_NAME,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const mileageApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_kilometrage,Select' }
        });
        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (data: Partial<MileageLog>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_kilometrage,Insert',
            VEH_IDF: data.vehicleId,
            DRV_IDF: data.driverId,
            KLM_DATE_DEBUT: data.startDate ? data.startDate.toISOString() : new Date().toISOString(),
            KLM_DATE_FIN: data.endDate ? data.endDate.toISOString() : new Date().toISOString(),
            KLM_KM_DEBUT: data.startKm,
            KLM_KM_FIN: data.endKm
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    update: async (id: number, data: Partial<MileageLog>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_kilometrage,Update',
            KLM_IDF: id,
            VEH_IDF: data.vehicleId,
            DRV_IDF: data.driverId,
            KLM_DATE_DEBUT: data.startDate ? data.startDate.toISOString() : undefined,
            KLM_DATE_FIN: data.endDate ? data.endDate.toISOString() : undefined,
            KLM_KM_DEBUT: data.startKm,
            KLM_KM_FIN: data.endKm
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_kilometrage,Delete', KLM_IDF: id }
        });
        return response;
    }
};
